import { useState, useEffect } from "react";
import { Card, Col, Row } from "antd";
import "../styles/layoutStyles.css";
import "./HomePageStyles.css";
const CardTesting2 = (props) => {
  const [newElements, setNewElements] = useState();
  const [load, setLoad] = useState(true);

  const settingData = () => {
    setNewElements(
      props.data?.sub_applications.map((application) => application.name)
    );
  };
  useEffect(() => {
    settingData();
    setLoad(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isAvailable = (name) => newElements.includes(name);

  const handleRedirect = (name) => {
    const targetUrl = props.data?.sub_applications?.find(
      (app) => app.name === name
    )?.url;
    if (targetUrl) window.location.href = targetUrl;
  };

  const logos = [
    {
      name: "DelegateHR",
      logo: props.applications?.find((app) => app.name === "DelegateHR")
        ?.application_logo,
    },
    {
      name: "CompBLDR",
      logo: props.applications?.find((app) => app.name === "Comp Project")
        ?.application_logo,
    },
    {
      name: "Review Cloud",
      logo: props.applications?.find((app) => app.name === "Review Cloud")
        ?.application_logo,
    },
  ];
  const handleKnowMore = (name) => {
    // You can customize this action (e.g., open a modal, redirect, etc.)
    window.open("https://trainery.com/contact", "_blank");
  };
  return (
    <>
      {load ? (
        <div></div>
      ) : (
        <div
          style={{
            width: "90%",
            margin: "0 auto",
            marginBottom: "10px",
            marginTop: 35,
          }}
        >
          <Card
            bordered={false}
            style={{ borderRadius: 16, overflow: "hidden" }}
            title={
              <div className="moving-gradient-header">
                <span>TRAINERY HCM</span>
              </div>
            }
            headStyle={{
              padding: 0,
              borderBottom: "none",
            }}
            bodyStyle={{
              padding: 24,
            }}
          >
            <Row gutter={[18, 18]}>
              {logos.map(({ name, logo }) => {
                const available = isAvailable(name);
                return (
                  <Col xs={24} sm={12} key={name}>
                    <div
                      onClick={() => available && handleRedirect(name)}
                      className={`logo-card-item ${
                        available ? "available" : "unavailable"
                      }`}
                    >
                      <img src={logo} alt={name} />
                      {!available && (
                        <div
                          className="logo-card-hover-message"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleKnowMore(name);
                          }}
                        >
                          <span>
                            You don't have access.
                            <br />
                            <span
                              style={{
                                color: "#1677ff",
                                // textDecoration: "underline",
                              }}
                            >
                              Click to know more
                            </span>
                          </span>
                        </div>
                      )}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Card>
        </div>
      )}
    </>
  );
};

export default CardTesting2;
